<template>
  <v-container style="overflow: auto; min-height: 700px; max-height: 700px;">
    <v-row class="pt-10 px-4" justify="center">
      <v-col cols="12" align="center">
        <span class="w-700 font-18 text-333333">แบบบันทึกการเยี่ยมบ้าน รายบุคคล คลินิกการพยาบาลและการผดุงครรภ์</span>
      </v-col>
    </v-row>
    <v-row class="px-4" justify="center">
      <v-col cols="12" align="center">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">ชื่อโรงพยาบาล/คลินิก</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{clinic_name || '-'}}</span>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col cols="12" xl="6" lg="5" md="4" sm="4" class="py-0">
        <span class="font-16 w-700 text-333333">ข้อมูลทั่วไป </span>
      </v-col>
      <v-col cols="12" xl="6" lg="7" md="8" sm="8" class="py-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">Authentication Code </span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{authentication_code || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="5" md="5" lg="6" xl="6" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">ชื่อ-สกุล</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.fullname || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="2" xl="2" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">เพศ</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.gender || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">วัน/เดือน/ปีเกิด</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{showBirthDate(general_info.birth_date) || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">เชื้อชาติ</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.race || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">สัญชาติ</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.nationality || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">เลขบัตรประจำตัวประชาชน</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{splitDat() || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">รหัสโรคหลัก</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.primary_disease_code || '-'}}</span>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">รหัสโรครอง</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.secondary_disease_code || '-'}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-6 font-16 w-700 text-333333 align-self-center">สิทธิการรักษาพยาบาล</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_right.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_right.detail}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.medical_right.status == '4'">{{general_info.medical_right.title}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-row no-gutters style="align-self:center;">
          <span class="pr-3 font-16 w-700 text-333333 align-self-center">ที่อยู่ (ตามบัตรประชาชน)</span>
          <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.officail_address || '-'}}</span>
        </v-row>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-row no-gutters style="align-self:center;">
          <span class="pr-3 font-16 w-700 text-333333 align-self-center">ที่อยู่ (ที่สามารถติดต่อได้)</span>
          <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.addressable || '-'}}</span>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">เบอร์โทรศัพท์</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{splitDatMobile() || '-'}}</span>
      </v-col>
      <v-col lg="8" xl="8"></v-col>
      <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="pb-0">
        <v-row no-gutters style="align-self:center;">
          <span class="pr-3 font-16 w-700 text-333333 align-self-center">ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ ชื่อ-สกุล</span>
          <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.emergency_contact_name || '-'}}</span>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
        <span class="pr-3 font-16 w-700 text-333333 align-self-center">เบอร์โทรศัพท์</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{splitDatMobile2() || '-'}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-6 font-16 w-700 text-333333 align-self-center">สถานภาพ</span>  
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.status_profile.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.status_profile.status == '4'">{{general_info.status_profile.detail}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-6 font-16 w-700 text-333333 align-self-center">ประเภทผู้ป่วย</span>  
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.patient_type.id}} {{general_info.patient_type.title}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-row no-gutters style="align-self:center;">
          <span class="pr-3 text-333333 font-16 w-700 align-self-center">ข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน</span>
          <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.home_visit_reason || '-'}}</span>
        </v-row>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-3 pt-2 text-333333 font-16 w-700">โรคประจำตัว</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.congenital_disease.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.congenital_disease.status == '2'">ระบุ {{general_info.congenital_disease.detail}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-row no-gutters style="align-self:center;">
          <v-col cols="auto" class="pa-0">
            <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการรักษา</span>
          </v-col>
          <v-col cols="10" class="pa-0">
            <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_history.hospital.title || '-'}}</span>
            <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_history.hospital.detail}}</span><br />
            <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_history.surgery.title || '-'}}</span>
            <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.medical_history.surgery.detail}}</span>
          </v-col>
        </v-row>
        
        </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการแพ้ยา</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.drug_allergy.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.drug_allergy.status == '1'">{{general_info.drug_allergy.detail}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-3 pt-2 text-333333 font-16 w-700">ประวัติการแพ้อาหาร</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.food_allergies.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.food_allergies.status == '1'">{{general_info.food_allergies.detail}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <span class="pr-6 pt-2 text-333333 font-16 w-700">ประเมินสมรรถนะผู้ป่วย</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center">{{general_info.patient_performance.title || '-'}}</span>
        <span class="pr-3 font-16 w-500 text-333333 align-self-center" v-if="general_info.patient_performance.status == '3'">{{general_info.patient_performance.detail}}</span>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-row no-gutters>
          <span class="pr-3 w-700 font-16 text-333333">Problem list โรค / ปัญหาที่พบ</span>
          <v-col cols="12" xl="8" lg="8" md="8" sm="8">
             <v-row v-for="(item, index) in general_info.problem_list" :key="index">
              <v-col cols="12"  class="pb-0" v-if="general_info.problem_list[index].detail !== ''">
                <span class="pr-3 py-0 text-333333 w-500 font-16">{{ index+ 1 }}.</span>
                <span class="pr-3 py-0 text-333333 w-500 font-16">{{general_info.problem_list[index].detail}}</span>
              </v-col>
              <v-col cols="12"  class="pb-0" v-else>
                <span class="pr-3 py-0 text-333333 w-500 font-16">-</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import functioncryto from "@/services/encrypt.js";
export default {
  data() {
    return {
      dialog: false,
      reveal: false,
      checkbox_addressable: true,
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      // data_addressable: {
      //   house_no: "",
      //   moo_no: "",
      //   soi: "",
      //   tambon: "",
      //   amphur: "",
      //   province: "",
      //   zipcode: "",
      //   address: ""
      // },

      //แบบบันทึกการเยี่ยมบ้าน รายบุคคล คลินิกการพยาบาลและการผดุงครรภ์
      menubirth_date: false,
      yearmax: "",

      clinic_name: "", //ชื่อ คลินิก
      authentication_code: "",
      general_info: { //ข้อมูลทั่วไป
        fullname: "",
        gender: "",
        birth_date: "",
        race: "", //เชื้อชาติ
        nationality: "", //สัญชาติ
        card_num: "", //เลขบัตรประจ้าตัวประชาชน
        primary_disease_code: '', //รหัสโรคหลัก
        secondary_disease_code: '', //รหัสโรครอง
        medical_right: { //สิทธิการรักษาพยาบาล
          status: "",
          detail: "",
          title: ""
        },
        officail_address: "", //ที่อยู่ (ตามบัตรประชาชน)
        addressable: "", //ที่อยู่ (ที่สามารถติดต่อได้)
        mobile: "",
        emergency_contact_mobile: "", //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้เบอร์โทรศัพท
        emergency_contact_name: "", //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ชื่อ-สกุล
        status_profile: 
        { //สถานภาพ
          status: "",
          detail: "",
          title: ""
        },
        patient_type: [],
        home_visit_reason: "", //ข้อบ่งชี้ เหตุผลในการเยี่ยมบ้าน
        congenital_disease: {
          status: "",
          detail: "",
          title: ""
        },
        medical_history: { //ประวัติการรักษา
          hospital: {
            status: "",
            detail: "",
            title: ""
          },
          surgery: {
            status: "",
            detail: "",
            title: ""
          }
        },
        drug_allergy: { //ประวัติการแพ้ยา
          status: "",
          detail: "",
          title: ""
        },
        food_allergies: { //ประวัติการแพ้อาหาร
          status: "",
          detail: "",
          title: ""
        },
        patient_performance: { //ประเมินสมรรถนะผู้ป่วย
          status: "",
          detail: "",
          title: ""
        },
        problem_list: [ //โรค ปัญหาที่พบ
          {
            id: 1,
            detail: "",
          },
          {
            id: 2,
            detail: "",
          },
          {
            id: 3,
            detail: "",
          }
        ]
      },
      rule_house_no: [(v) => !!v || "กรุณากรอกชื่อ"],
      rule_moo_no: [(v) => !!v || "กรุณากรอกชื่อ"],
      rule_amphur: [(v) => !!v || "กรุณากรอกชื่อ"],
      rule_tambon: [(v) => !!v || "กรุณากรอกชื่อ"],
      rule_province: [(v) => !!v || "กรุณากรอกชื่อ"],
      rule_zipcode: [(v) => !!v || "กรุณากรอกชื่อ"],
    }
  },
  computed: {
    formatBirthDate() {
      var year1 = "";
      var year2 = "";
      if (this.general_info.birth_date === undefined || this.general_info.birth_date === "")
        return "";
      year1 = moment(this.general_info.birth_date).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      return moment(this.general_info.birth_date)
        .locale("th")
        .format("DD/MM/" + year2);
    },
  },
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
  },
  async created() {
    // await this.set_value()
    // await this.getProvince();
  },
  methods: {
    splitDat() {
      return this.general_info.card_num.substring(0,1)+'-'+
            this.general_info.card_num.substring(1,5)+'-'+
            this.general_info.card_num.substring(5,10)+'-'+
            this.general_info.card_num.substring(10,12)+'-'+
            this.general_info.card_num.substring(12,13)
    },
    splitDatMobile() {
      if(this.general_info.mobile.length == 10) {
        return this.general_info.mobile.substring(0,3)+'-'+this.general_info.mobile.substring(3,6)+'-'+this.general_info.mobile.substring(6,10)
      } else if(this.general_info.mobile.length == 9) {
        return this.general_info.mobile.substring(0,1)+'-'+this.general_info.mobile.substring(1,5)+'-'+this.general_info.mobile.substring(5,9)
      }
    },
    splitDatMobile2() {
      if(this.general_info.emergency_contact_mobile.length == 10) {
        return this.general_info.emergency_contact_mobile.substring(0,3)+'-'+this.general_info.emergency_contact_mobile.substring(3,6)+'-'+this.general_info.emergency_contact_mobile.substring(6,10)
      } else if(this.general_info.emergency_contact_mobile == 9) {
        return this.general_info.emergency_contact_mobile.substring(0,1)+'-'+this.general_info.emergency_contact_mobile.substring(1,5)+'-'+this.general_info.emergency_contact_mobile.substring(5,9)
      }
    },
    async openPage(item, individual_home_visits) {
      console.log('individual_home_visits record', individual_home_visits);

      this.clinic_name = individual_home_visits !== null && 'clinic_name' in individual_home_visits && individual_home_visits.clinic_name !== '' && individual_home_visits.clinic_name !== null && individual_home_visits.clinic_name !== undefined ? individual_home_visits.clinic_name : '',
      this.authentication_code = individual_home_visits !== null && 'authentication_code' in individual_home_visits && individual_home_visits.authentication_code !== '' && individual_home_visits.authentication_code !== null && individual_home_visits.authentication_code !== undefined ? individual_home_visits.authentication_code : '',
      this.general_info = { //ข้อมูลทั่วไป
        fullname: 'fullname' in item && item.fullname !== '' && item.fullname !== null && item.fullname !== undefined ? item.fullname : '',
        gender: 'gender' in item && item.gender !== '' && item.gender !== null && item.gender !== undefined ? item.gender : '',
        birth_date: 'birth_date' in item && item.birth_date !== '' && item.birth_date !== null && item.birth_date !== undefined ? item.birth_date : '',
        race: individual_home_visits !== null && 'general_info' in individual_home_visits && 'race' in individual_home_visits.general_info && individual_home_visits.general_info.race !== '' && individual_home_visits.general_info.race !== null && individual_home_visits.general_info.race !== undefined ? individual_home_visits.general_info.race : '', //เชื้อชาติ
        nationality: individual_home_visits !== null && 'general_info' in individual_home_visits && 'nationality' in individual_home_visits.general_info && individual_home_visits.general_info.nationality !== '' && individual_home_visits.general_info.nationality !== null && individual_home_visits.general_info.nationality !== undefined ? individual_home_visits.general_info.nationality : '', //สัญชาติ
        card_num: 'cid' in item && item.cid !== '' && item.cid !== null && item.cid !== undefined ? await this.showCID(item.cid) : '', //เลขบัตรประจ้าตัวประชาชน
        primary_disease_code: individual_home_visits !== null && 'general_info' in individual_home_visits && 'primary_disease_code' in individual_home_visits.general_info && individual_home_visits.general_info.primary_disease_code !== '' && individual_home_visits.general_info.primary_disease_code !== null && individual_home_visits.general_info.primary_disease_code !== undefined ? individual_home_visits.general_info.primary_disease_code : '',
        secondary_disease_code: individual_home_visits !== null && 'general_info' in individual_home_visits && 'secondary_disease_code' in individual_home_visits.general_info && individual_home_visits.general_info.secondary_disease_code !== '' && individual_home_visits.general_info.secondary_disease_code !== null && individual_home_visits.general_info.secondary_disease_code !== undefined ? individual_home_visits.general_info.secondary_disease_code : '',
        medical_right: { //สิทธิการรักษาพยาบาล
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.status !== '' && individual_home_visits.general_info.medical_right.status !== null && individual_home_visits.general_info.medical_right.status !== undefined ? individual_home_visits.general_info.medical_right.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.detail !== '' && individual_home_visits.general_info.medical_right.detail !== null && individual_home_visits.general_info.medical_right.detail !== undefined ? individual_home_visits.general_info.medical_right.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_right' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.medical_right && individual_home_visits.general_info.medical_right.title !== '' && individual_home_visits.general_info.medical_right.title !== null && individual_home_visits.general_info.medical_right.title !== undefined ? individual_home_visits.general_info.medical_right.title : '',
        },
        officail_address: individual_home_visits !== null && 'general_info' in individual_home_visits && 'officail_address' in individual_home_visits.general_info && individual_home_visits.general_info.officail_address !== '' && individual_home_visits.general_info.officail_address !== null && individual_home_visits.general_info.officail_address !== undefined ? individual_home_visits.general_info.officail_address : '',
        addressable: individual_home_visits !== null && 'general_info' in individual_home_visits && 'addressable' in individual_home_visits.general_info && individual_home_visits.general_info.addressable !== '' && individual_home_visits.general_info.addressable !== null && individual_home_visits.general_info.addressable !== undefined ? individual_home_visits.general_info.addressable : '', //ที่อยู่ (ที่สามารถติดต่อได้)
        mobile: 'mobile' in item && item.mobile !== '' && item.mobile !== null && item.mobile !== undefined ? item.mobile : '',
        emergency_contact_mobile: individual_home_visits !== null && 'general_info' in individual_home_visits && 'emergency_contact_mobile' in individual_home_visits.general_info && individual_home_visits.general_info.emergency_contact_mobile !== '' && individual_home_visits.general_info.emergency_contact_mobile !== null && individual_home_visits.general_info.emergency_contact_mobile !== undefined ? individual_home_visits.general_info.emergency_contact_mobile : '', //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้เบอร์โทรศัพท
        emergency_contact_name: individual_home_visits !== null && 'general_info' in individual_home_visits && 'emergency_contact_name' in individual_home_visits.general_info && individual_home_visits.general_info.emergency_contact_name !== '' && individual_home_visits.general_info.emergency_contact_name !== null && individual_home_visits.general_info.emergency_contact_name !== undefined ? individual_home_visits.general_info.emergency_contact_name : '', //ในกรณีฉุกเฉินบุคคลที่สามารถติดต่อได้ชื่อ-สกุล
        status_profile: 
        { //สถานภาพ
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.status !== '' && individual_home_visits.general_info.status_profile.status !== null && individual_home_visits.general_info.status_profile.status !== undefined ? individual_home_visits.general_info.status_profile.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.detail !== '' && individual_home_visits.general_info.status_profile.detail !== null && individual_home_visits.general_info.status_profile.detail !== undefined ? individual_home_visits.general_info.status_profile.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'status_profile' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.status_profile && individual_home_visits.general_info.status_profile.title !== '' && individual_home_visits.general_info.status_profile.title !== null && individual_home_visits.general_info.status_profile.title !== undefined ? individual_home_visits.general_info.status_profile.title : '',
        },
        patient_type: {
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.status !== '' && individual_home_visits.general_info.patient_type.status !== null && individual_home_visits.general_info.patient_type.status !== undefined ? individual_home_visits.general_info.patient_type.status : '',
          id: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'id' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.id !== '' && individual_home_visits.general_info.patient_type.id !== null && individual_home_visits.general_info.patient_type.id !== undefined ? individual_home_visits.general_info.patient_type.id : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_type' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.patient_type && individual_home_visits.general_info.patient_type.title !== '' && individual_home_visits.general_info.patient_type.title !== null && individual_home_visits.general_info.patient_type.title !== undefined ? individual_home_visits.general_info.patient_type.title : '',
        },
        
        home_visit_reason: individual_home_visits !== null && 'general_info' in individual_home_visits && 'home_visit_reason' in individual_home_visits.general_info && individual_home_visits.general_info.home_visit_reason !== '' && individual_home_visits.general_info.home_visit_reason !== null && individual_home_visits.general_info.home_visit_reason !== undefined ? individual_home_visits.general_info.home_visit_reason : '',
        congenital_disease: {
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.status !== '' && individual_home_visits.general_info.congenital_disease.status !== null && individual_home_visits.general_info.congenital_disease.status !== undefined ? individual_home_visits.general_info.congenital_disease.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.detail !== '' && individual_home_visits.general_info.congenital_disease.detail !== null && individual_home_visits.general_info.congenital_disease.detail !== undefined ? individual_home_visits.general_info.congenital_disease.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'congenital_disease' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.congenital_disease && individual_home_visits.general_info.congenital_disease.title !== '' && individual_home_visits.general_info.congenital_disease.title !== null && individual_home_visits.general_info.congenital_disease.title !== undefined ? individual_home_visits.general_info.congenital_disease.title : '',
        },
        medical_history: { //ประวัติการรักษา
          hospital: {
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'status' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.status !== '' && individual_home_visits.general_info.medical_history.hospital.status !== null && individual_home_visits.general_info.medical_history.hospital.status !== undefined ? individual_home_visits.general_info.medical_history.hospital.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'detail' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.detail !== '' && individual_home_visits.general_info.medical_history.hospital.detail !== null && individual_home_visits.general_info.medical_history.hospital.detail !== undefined ? individual_home_visits.general_info.medical_history.hospital.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'hospital' in individual_home_visits.general_info.medical_history && 'title' in individual_home_visits.general_info.medical_history.hospital && individual_home_visits.general_info.medical_history.hospital.title !== '' && individual_home_visits.general_info.medical_history.hospital.title !== null && individual_home_visits.general_info.medical_history.hospital.title !== undefined ? individual_home_visits.general_info.medical_history.hospital.title : '',
          },
          surgery: {
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'status' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.status !== '' && individual_home_visits.general_info.medical_history.surgery.status !== null && individual_home_visits.general_info.medical_history.surgery.status !== undefined ? individual_home_visits.general_info.medical_history.surgery.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'detail' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.detail !== '' && individual_home_visits.general_info.medical_history.surgery.detail !== null && individual_home_visits.general_info.medical_history.surgery.detail !== undefined ? individual_home_visits.general_info.medical_history.surgery.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'medical_history' in individual_home_visits.general_info && 'surgery' in individual_home_visits.general_info.medical_history && 'title' in individual_home_visits.general_info.medical_history.surgery && individual_home_visits.general_info.medical_history.surgery.title !== '' && individual_home_visits.general_info.medical_history.surgery.title !== null && individual_home_visits.general_info.medical_history.surgery.title !== undefined ? individual_home_visits.general_info.medical_history.surgery.title : '',
          }
        },
        drug_allergy: { //ประวัติการแพ้ยา
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.status !== '' && individual_home_visits.general_info.drug_allergy.status !== null && individual_home_visits.general_info.drug_allergy.status !== undefined ? individual_home_visits.general_info.drug_allergy.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.detail !== '' && individual_home_visits.general_info.drug_allergy.detail !== null && individual_home_visits.general_info.drug_allergy.detail !== undefined ? individual_home_visits.general_info.drug_allergy.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'drug_allergy' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.drug_allergy && individual_home_visits.general_info.drug_allergy.title !== '' && individual_home_visits.general_info.drug_allergy.title !== null && individual_home_visits.general_info.drug_allergy.title !== undefined ? individual_home_visits.general_info.drug_allergy.title : '',
        },
        food_allergies: { //ประวัติการแพ้อาหาร
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.status !== '' && individual_home_visits.general_info.food_allergies.status !== null && individual_home_visits.general_info.food_allergies.status !== undefined ? individual_home_visits.general_info.food_allergies.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.detail !== '' && individual_home_visits.general_info.food_allergies.detail !== null && individual_home_visits.general_info.food_allergies.detail !== undefined ? individual_home_visits.general_info.food_allergies.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'food_allergies' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.food_allergies && individual_home_visits.general_info.food_allergies.title !== '' && individual_home_visits.general_info.food_allergies.title !== null && individual_home_visits.general_info.food_allergies.title !== undefined ? individual_home_visits.general_info.food_allergies.title : '',
        },
        patient_performance: { //ประเมินสมรรถนะผู้ป่วย
          status: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'status' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.status !== '' && individual_home_visits.general_info.patient_performance.status !== null && individual_home_visits.general_info.patient_performance.status !== undefined ? individual_home_visits.general_info.patient_performance.status : '',
          detail: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'detail' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.detail !== '' && individual_home_visits.general_info.patient_performance.detail !== null && individual_home_visits.general_info.patient_performance.detail !== undefined ? individual_home_visits.general_info.patient_performance.detail : '',
          title: individual_home_visits !== null && 'general_info' in individual_home_visits && 'patient_performance' in individual_home_visits.general_info && 'title' in individual_home_visits.general_info.patient_performance && individual_home_visits.general_info.patient_performance.title !== '' && individual_home_visits.general_info.patient_performance.title !== null && individual_home_visits.general_info.patient_performance.title !== undefined ? individual_home_visits.general_info.patient_performance.title : '',
        },
        problem_list: individual_home_visits !== null && 'general_info' in individual_home_visits && 'problem_list' in individual_home_visits.general_info && individual_home_visits.general_info.problem_list.length !== 0 && individual_home_visits.general_info.problem_list !== null && individual_home_visits.general_info.problem_list !== undefined ? individual_home_visits.general_info.problem_list : [{id: 1,detail: ""}] ,
      }
    },
    async showCID(item) {
      // const maskedDigits = "X".repeat(6);
      // const visibleDigits = functioncryto.decrypt(item).substring(6);
      // return maskedDigits + visibleDigits;
      const cid = await functioncryto.decrypt(item);
      return cid
    },
    showBirthDate(date) {
      if(date) {
        var year1 = "";
        var year2 = "";
        year1 = moment(date).locale("th").format("YYYY");
        year2 = (parseInt(year1) + 543).toString();
        return moment(date).locale("th").format("DD/MM/" + year2);
      } else {
        return '-'
      }
    },
    aad_list() {
      this.general_info.problem_list.push({ id: this.general_info.problem_list.length + 1, detail: '', title: '' })
    },
    delete_list(index) {
      if (this.general_info.problem_list.length === 1) {
        this.general_info.problem_list = [
          {
            id: this.general_info.problem_list.length,
            detail: '',
            title: ''
          }
        ]
      } else {
        this.general_info.problem_list.splice(index, 1);
      }
    },
  }
}
</script>

<style scoped>
.text_start {
  text-align: start;
  padding-bottom: 0px;
  justify-self: center;
  align-self: start;
  
}
.text_checkbox {
  align-self: start !important;
}
.text_name {
  text-align: end;
  padding-bottom: 0px;
  justify-self: center;
  align-self: center;
}

::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
::v-deep .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #00A99D !important;
}
.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 8px;
  align-self: start !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41;
}

::v-deep .v-input--is-disabled > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep
  .v-text-field.v-text-field--solo.v-input--dense
  .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #313b41 !important;
}
::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}

::v-deep .set-checkbox .v-input--selection-controls__input {
  align-self: start !important;
}
</style>